import resolveLink from "~/helpers/resolveLink";

const isMailto = (url: string): boolean => url.toLowerCase().startsWith("mailto:");

// target=_blank on a mailto: handoff leaves a dead blank tab behind.
export const contactLinkAnchorProps = (url: string): { rel?: string; target?: string } =>
	isMailto(url) ? {} : { rel: "noopener noreferrer", target: "_blank" };

const resolveContactLink = (rawUrl: string | undefined): string | undefined => {
	const trimmed = rawUrl?.trim();
	if (!trimmed) return undefined;
	if (isMailto(trimmed)) return trimmed.length > "mailto:".length ? trimmed : undefined;
	return resolveLink(trimmed);
};

export default resolveContactLink;
